module.exports = __webpack_public_path__ + "static/media/whiteDrop.7a36288c.svg";